import React, { useContext, useState } from 'react';
import type { GridApi } from 'ag-grid-community';

import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';
import GqlClientProvider from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import CanvasCard from '../Visualisations/CanvasCard';
import { TopBar } from '../V5Gadget/Matrix';
import DashboardGadgetBottomBar from '../DashboardGadgetBottomBar';
import PaceMatrixContent from './PaceMatrixContent';
import { ChartTopBar } from '../Chart';

const PaceMatrix = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.PaceMatrix;
}) => {
  const [gridApi, setGridApi] = useState<GridApi>();
  const [exportHandle, setExportHandle] = useState<DataTable.ExportHandle>();
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      isContentWithoutPadding
      topBar={
        (gridApi || exportHandle) && !gadget.isCardMode ? (
          <TopBar
            gridApi={gridApi}
            exportHandle={exportHandle}
            exportName={gadget.name}
            chartDefinition={gadget}
            title={gadget.name}
          />
        ) : (
          <ChartTopBar chartDefinition={gadget} />
        )
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
      content={
        <GqlClientProvider
          visName={gadget.name}
          visId={gadget.id}
          visType={gadget.type}
        >
          <PaceMatrixContent
            gadget={gadget}
            gridApi={gridApi}
            setGridApi={setGridApi}
            setExportHandle={setExportHandle}
          />
        </GqlClientProvider>
      }
    />
  );
};

export default PaceMatrix;
